import React, {useEffect, useState} from "react"
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import {withRouter} from "react-router-dom";

import MaterialSpinner from "../../../ui/materialSpinner";
import {getImagePromiseFromLayout} from "../../../../misc/getCanvasImageFromLayout";
import {createFakeLayout, getCurrentLayout} from "../../../appLayout";
import {useIsMounted} from "../../../../misc/helperHooks";
import {
  setLookOpened,
  setLookOverlayOpened,
  setLookPageOpened,
  setLookViewChangeOptions
} from "../../../../actions/lookFunctions";
import {LOOK_OVERLAYS} from "../../core/constants";
import {baseNewImagesPath} from "../../../assets";
// import Config from "../../../../config";
import {ROUTES} from "../../../../routes";
import Analytics, {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";
import {zoomCanvasOut} from "../../lookNavigation/lookFunctions";
import {setCanvasScale} from "../../../../actions/actionFunctions";
import LookCanvasContext from "../../lookCanvasContext";

const GroheLayoutItem = (props) => {

  const {look, imageOnly, setLookOverlayOpened, setLookViewChangeOptions, history, setLookPageOpened, setLookOpened,
    setCanvasScale} = props;
  const isMounted = useIsMounted();

  const layout = getCurrentLayout();
  const type = layout.layoutTypes[look.lookLayout];
  const [thumbnailUrl, setThumbnailUrl] = useState(
    layout.layoutThumbnails && layout.layoutThumbnails[look.lookLayout] ? layout.layoutThumbnails[look.lookLayout] : ""
  );
  const isActive = type === layout.type && layout.scene === look.lookScene;

  const handleLayoutItemClick = (imageCanvas) => {
    const analyticsQuery = `layout_type=${type}-scene=${look.lookScene}`;
    Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.productRoom + analyticsQuery);
    if (!isActive) {
      setLookOverlayOpened(LOOK_OVERLAYS.questionView);
      setLookViewChangeOptions({
        newLayoutType: type,
        newScene: look.lookScene,
        itemsToRemove: [], //todo
      })
    } else {
      setLookOpened(null);
      setLookPageOpened("");
      setLookOverlayOpened("");
      history.push(ROUTES.home);
      zoomCanvasOut(imageCanvas, setCanvasScale);
    }
  }

  useEffect(() => {
    if (!thumbnailUrl) {
      const getLayoutThumbnail = async () => {
        const fakeLayout = isActive ? layout : createFakeLayout(layout, look.lookLayout, look.lookScene);
        if (!isActive) {
          const currentState = layout.getActiveFeaturesAsObject(true, false, true); // get current selected features
          await fakeLayout.selectLayout(type, layout.type, currentState, look.lookScene, null, true);
        }
        getImagePromiseFromLayout(fakeLayout, null, 1)
          .then(response => {
            // console.log("response", response);
            if (isMounted()) {
              setThumbnailUrl(response);
            }
          })

      }
      getLayoutThumbnail(isMounted);
    } else if (!thumbnailUrl) {
      setThumbnailUrl(`${baseNewImagesPath}images/image-not-found.png`);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (imageOnly) {
    return <img src={thumbnailUrl} className="layout-image" alt="item.type"/>
  }

  return (
    <LookCanvasContext.Consumer>
      {(imageCanvas) => (
        <li className="ll-layout ll-room" onClick={() => handleLayoutItemClick(imageCanvas)}>
          <div className="ll-layout__thumbnail" style={{backgroundImage: `url(${thumbnailUrl})`}}>
            {thumbnailUrl ? null : <MaterialSpinner/>}
          </div>
          <div className="ll-layout__content">
            <div className="ll-layout__content-title bold">
              <span className="ll-layout__content-title-name">
                <FormattedMessage id="look.layout.item.view"/> {look.lookLayout}
              </span>
              {/*<span className="ll-layout__content-title-name">RoomLayout: {roomPreset.layout_type}</span>*/}
              {/*<span className="ll-layout__content-title-sqm">RoomScene: {roomPreset.scene}</span>*/}
            </div>
            {/*<div className="ll-layout__content-description">Price: ${roomPreset.presetPrice || 0}</div>*/}
          </div>
        </li>
      )}
    </LookCanvasContext.Consumer>
  );
}

GroheLayoutItem.propTypes = {
  look: PropTypes.object.isRequired,
  isMobile: PropTypes.bool,
  imageOnly: PropTypes.bool,
}

const mapStateToProps = () => {
  return {
  };
};

const mapDispatchToProps = {
  setLookOpened,
  setLookPageOpened,
  setLookOverlayOpened,
  setLookViewChangeOptions,
  setCanvasScale,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(GroheLayoutItem)
)
